import React, { useEffect, useState } from 'react';
import serverStore from '../../../stores/server.store';
import uptimeStore from '../../../stores/uptime.store';
import mongoDbStore from '../../../stores/mongodb.store';
import Header from '../../components/header/Header';
import LoaderComponent from '../../components/Loader.component';
import MongoItemWrapper from './components/MongoItem';
import mongoDbMetricsStore from '../../../stores/mongoMetrics.store';
import { addToast } from '../../components/toasts/Toast';
import { startPolling } from '../../../servises/polling.service';
import { Redirect } from 'react-router-dom';
import { loadDetailData } from '../../../servises/detail-loading.service';
import MonitorLoadError from './components/MonitorLoadError';

const MongoItemPage = props => {
    document.title = 'Monitors - SyAgent';
    const { serverId } = props.match.params;

    const [loader, setLoader] = useState(true);
    const [loadedServerId, setLoadedServerId] = useState(null);
    const [mongoListLoaded, setMongoListLoaded] = useState(false);
    const [loadError, setLoadError] = useState(false);
    const [loadSequence, setLoadSequence] = useState(0);

    useEffect(() => {
        let active = true;
        setLoader(true);
        setMongoListLoaded(false);
        setLoadError(false);
        mongoDbMetricsStore.clear();
        const getServersData = async () => {
            const secondaryFailed = await loadDetailData(
                mongoDbStore.getMongoDb(true),
                [
                    serverStore.getServers(),
                    uptimeStore.getUptime(),
                    mongoDbMetricsStore.getMongoMetrics(serverId)
                ]
            );
            if (secondaryFailed) {
                addToast('Some monitor data could not be loaded', 'error');
            }
            if (active) {
                setMongoListLoaded(true);
            }
        };
        getServersData()
            .catch(error => {
                addToast(error.message || 'Failed to load monitor', 'error');
                if (active) {
                    setLoadError(true);
                }
            })
            .finally(() => {
                if (active) {
                    setLoadedServerId(serverId);
                    setLoader(false);
                }
            });
        return () => {
            active = false;
        };
    }, [serverId, loadSequence]);

    useEffect(() => {
        return startPolling(
            () => mongoDbMetricsStore.getMongoMetrics(serverId),
            60000,
            error => addToast(
                error.message || 'Failed to refresh monitor',
                'error',
                'monitor-refresh'
            )
        );
    }, [serverId]);

    if (loadError) {
        return <MonitorLoadError onRetry={ () => setLoadSequence(value => value + 1) }/>;
    }

    return (
        <main className="servers">
            <Header/>
            { (loader || loadedServerId !== serverId) && (
                <LoaderComponent/>
            ) }

            { !loader && loadedServerId === serverId && (
                <>
                    { mongoListLoaded && !mongoDbStore.mongoDbListObj[serverId] && (
                        <Redirect to="/404"/>
                    ) }
                    { mongoListLoaded && mongoDbStore.mongoDbListObj[serverId] && (
                        <MongoItemWrapper serverId={ serverId }/>
                    ) }
                </>
            ) }
        </main>
    );
};

export default MongoItemPage;
